
import TableList from '../commom/tableList.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import {getEvaluationSave, quesSignSave} from 'api/evaluation'

export default {

components: {
Loading,
XHeader,
Group,
Flexbox,
FlexboxItem,
XButton,
Checker,
CheckerItem,
TableList
},
data () {
return {
text: '加载中',
params: '',
title: '风险承受等级'
}
},
created () {
this.params = this.$route.query
this.params.specialObj = this.$util.toBoolean(this.params.specialObj)
},
computed: {
level () {
switch (this.params.result) {
case 'C1':
return 'R1'
case 'C2':
return 'R1、R2'
case 'C3':
return 'R1、R2、R3'
case 'C4':
return 'R1、R2、R3、R4'
case 'C5':
return 'R1、R2、R3、R4、R5'
}
}
},
methods: {
$_evaluation_again () {
this.$router.push({path: '/evaluation/one'})
},
$_evaluation_checkSubmit () {
let isNeedSign = parseInt(this.params.isNeedSign)
if (isNeedSign === 1) {
this.$bridge.registerHandler('getSignData', (data) => {
this.$_getSignResult(data)
})
this.$bridge.callHandler('sign', {message: '用户签名', userId: this.params.userId, result: this.params.result}, (data) => {})
} else {
this.$_handleSubmit()
}
},

$_getSignResult (signFile) {
let data = {
sysCode: this.params.sysCode,
managerAdminUserId: this.params.managerId,
userId: this.params.invenstemUserId,  // 理财师添加的用户ID
platformUserId: this.params.platformUserId,
evaluationResultFile: this.params.evaluationResultFile,
signImagesFileInfo: signFile
}
console.log('合成签名提交的数据：', data)
this.$vux.loading.show({text: '签名合成中'})
quesSignSave(data, this.params.au).then((res) => {
this.$vux.loading.hide()
if (res.code === 0) {
console.log('签章合成返回', res)
this.params.evaluationResultFileSign = res.data.bean.evaluationResultFileSign
this.$vux.toast.show({text: '签署成功', type: 'success'})
this.$_handleSubmit()
} else {
this.$vux.toast.show({text: res.msg, type: 'warn'})
}
}).catch(e => {
this.$vux.loading.hide()
this.$vux.toast.show({text: '服务器繁忙, 请重试', type: 'warn'})
return Promise.reject(e)
})
},

$_handleSubmit () {
this.$vux.loading.show({text: '提交中'})
let subData = JSON.parse(this.params.subData)
subData.evaluationResultFile = this.params.evaluationResultFile         
subData.evaluationResultFileSign = this.params.evaluationResultFileSign       
console.log(subData)
getEvaluationSave(subData, this.params.au).then((res) => {
this.$vux.loading.hide()
if (res.code === 0) {
this.$_evaluation_submit(res.data.bean.evaluationId)
} else {
this.$vux.toast.show({type: 'warn', text: res.msg})
}
})
},
$_evaluation_submit (evaluationId) {
this.$vux.toast.show({type: 'success', text: '提交成功'})
this.$bridge.callHandler('getResult', {message: '最后确认', level: this.params.result, evaluationId}, function (data) {
console.log('submit')
})
},

$_view_quesDetail () {
let viewPdf = this.params.evaluationResultFileSign ? this.params.evaluationResultFileSign : this.params.evaluationResultFile
this.$bridge.callHandler('seePDF', {message: '查看pdf', pdfSign: viewPdf}, (data) => {
console.log('submit')
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/Evaluation/normal.vue